const getters = {
  getShipmentDaysList: (state) => (state.shipmentDaysList),
  getShipmentsIsFetching: (state) => (state.isFetching),
  getShipmentIsToggled: (state) => (shipmentID) => {
    const index = state.toggledShipments.indexOf(shipmentID)
    if (index < 0) {
      return false
    }
    return true
  },
  getShipmentDayIsToggled: (state) => (day) => {
    const dayIndex = state.shipmentDaysList.findIndex(({ date }) => date === day)
    if (dayIndex >= 0) {
      if (state.shipmentDaysList[dayIndex].shipments != null) {
        let flag = true
        if (state.shipmentDaysList[dayIndex].shipments.length < 1) {
          flag = false
        }
        state.shipmentDaysList[dayIndex].shipments.forEach(({ id }) => {
          if (state.toggledShipments.indexOf(id) < 0) {
            flag = false
          }
        })
        return flag
      }
    }
    return false
  },
  getShipmentsTotal: (state) => (state.total),
  getSelectedView: (state) => (state.selectedView),
  getLastDay: (state) => (state.lastDay),
  getRangesByType: (state) => (attribute) => {
    if (state.ranges != null) {
      const index = state.ranges.findIndex(({ type }) => (type === attribute))
      if (index >= 0) {
        return state.ranges[index]
      }
    }
    return {
      attribute,
      from: 0,
      to: 0
    }
  },
  getLastUrl: (state) => (state.lastUrl),
  getShipmentIDsPerDay: (state) => (day) => {
    const dayIndex = state.shipmentDaysList.findIndex(({ date }) => date === day)
    if (dayIndex >= 0) {
      if (state.shipmentDaysList[dayIndex].shipments != null) {
        if (state.shipmentDaysList[dayIndex].shipments.length > 0) {
          return state.shipmentDaysList[dayIndex].shipments.map(({ id }) => {
            return id
          })
        }
      }
    }
    return null
  },
  getShipmentsPerDay: (state) => (day) => {
    const dayIndex = state.shipmentDaysList.findIndex(({ date }) => date === day)
    if (dayIndex >= 0) {
      if (state.shipmentDaysList[dayIndex].shipments != null) {
        if (state.shipmentDaysList[dayIndex].shipments.length > 0) {
          return state.shipmentDaysList[dayIndex].shipments
        }
      }
    }
    return null
  },
  getShipmentsForExportPerDay: (state) => (day) => {
    const dayIndex = state.shipmentDaysList.findIndex(({ date }) => date === day)
    if (dayIndex >= 0) {
      if (state.shipmentDaysList[dayIndex].shipments != null) {
        if (state.shipmentDaysList[dayIndex].shipments.length > 0) {
          return state.shipmentDaysList[dayIndex].shipments
        }
      }
    }
    return null
  },
  getDayByShipmentID: (state) => (shipmentID) => {
    if (state.shipmentDaysList != null) {
      const findShipmentDayIndex = state.shipmentDaysList.findIndex(({ shipments }) => {
        return shipments.findIndex(({ id }) => id === shipmentID) >= 0
      })
      if (findShipmentDayIndex != null) {
        return state.shipmentDaysList[findShipmentDayIndex]
      }
    }
    return null
  }
}

export default getters
